<template>
  <Slide class="NetworkProvidersSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="nextSlide"
  >
    <MultiOptionSelect
      name="networkProviders"
      v-bind="{ error }"
      :prompt="content.prompt"
      :options="content.options"
      :value="fieldValues.networkProviders"
      :disabled="!isCurrentSlide"
      @selectionChange="doUpdateField"
    />
  </Slide>
</template>

<script>
import { multiOptionSelectSlideMixin } from '../util/slideBuilders.js'

import MultiOptionSelect from './elems/MultiOptionSelect.vue'
import Slide from './elems/Slide.vue'

export default {
  mixins: [multiOptionSelectSlideMixin],
  components: {
    MultiOptionSelect,
    Slide,
  },
  data() {
    return {
      fieldName: 'networkProviders',
    }
  },
}
</script>
